const conditionTableHeader = ['Expected Value', 'Found Value', 'Reason'];

export { conditionTableHeader };
